import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { DeviceSerialNumber, ExternalCamera, Organization, User } from '@pages/camera-settings/models';
import { ICheckInAttempts, ICheckOutAttempts, IFailedLoginAttempts, IMFAConfiguration, ISessionsCaptured, ITriggeredSenseDeviceHistory } from '@pages/reports/report/report.component';
@Injectable({
    providedIn: 'root'
})
export class OrganizationService extends ApiService {
    constructor(private http: HttpClient) {
        super();
    }
    getOrganizations(): Observable<Organization[]> {
        return this.http.get<Organization[]>(this.baseUrl + '/api/Organization/GetOrganization');
    }
}


@Injectable({
    providedIn: 'root'
})
export class UserService extends ApiService {
    constructor(private http: HttpClient) {
        super();
    }
    getUsers(companyId: number) {
        return this.http.get<User[]>(this.baseUrl + `/api/User/GetUsersByCompanyId?CompanyId=${companyId}`);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DeviceSerialNumberService extends ApiService {
    constructor(private http: HttpClient) {
        super();
    }
    getSerialNumbers() {
        return this.http.get<DeviceSerialNumber[]>(this.baseUrl + `/api/Report/GetTriggerDevicesSerialNumber`);
    }
}


@Injectable({
    providedIn: 'root'
})
export class ExternalCameraService extends ApiService {
    constructor(private http: HttpClient) {
        super();
    }
    getExternalCameras() {
        return this.http.get<ExternalCamera[]>(this.baseUrl + `/api/Report/GetExternalCameras`);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReportService extends ApiService {
    constructor(private http: HttpClient) {
        super();
    }
    getFailedLoginAttemptsReport(filter: any) {
        return this.http.get<IFailedLoginAttempts[]>(this.baseUrl + `/api/Report/User_LoginAttempt?UserId=${filter.userId}&CompanyId=${filter.companyId}&DateTo=${filter.dateTo}&DateFrom=${filter.dateFrom}`);
    }
    getMFAConfigurationReport(filter: any) {
        return this.http.get<IMFAConfiguration[]>(this.baseUrl + `/api/Report/MFAConfigured?UserId=${filter.userId}&CompanyId=${filter.companyId}`);
    }
    getUserCheckinReport(filter: any) {
        return this.http.get<ICheckInAttempts[]>(this.baseUrl + `/api/Report/User_CheckInAttemp?UserId=${filter.userId}&CompanyId=${filter.companyId}&DateTo=${filter.dateTo}&DateFrom=${filter.dateFrom}`);
    }
    getUserCheckoutReport(filter: any) {
        return this.http.get<ICheckOutAttempts[]>(this.baseUrl + `/api/Report/User_CheckOutAttempt?UserId=${filter.userId}&CompanyId=${filter.companyId}&DateTo=${filter.dateTo}&DateFrom=${filter.dateFrom}`);
    }
    sessionCapturedReport(filter: any) {
        return this.http.get<ISessionsCaptured[]>(this.baseUrl + `/api/Report/SessionCapturedByUser?UserId=${filter.userId}&CompanyId=${filter.companyId}&DeviceId=${filter.deviceId}&DateTo=${filter.dateTo}&DateFrom=${filter.dateFrom}`);
    }
    getDeviceSerialNumberReport(filter: any) {
        return this.http.get<ITriggeredSenseDeviceHistory[]>(this.baseUrl + `/api/Report/TriggeredSenseDeviceHistroy?SerialNumber=${filter.serialNumber}&CompanyId=${filter.companyId}&DateTo=${filter.dateTo}&DateFrom=${filter.dateFrom}`);
    }
}